import React, {useState} from 'react';
import moment from 'moment';
import { Transition, Button, List, Responsive, Icon, Modal, Popup } from "semantic-ui-react";
import 'moment/locale/pt-br';
import BotaoEditar from '../../layouts/BotaoEditar';
moment.locale('pt-BR');

const Unidade = ({ unidade, animation, bloquearHandle }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleModal = () => setModalOpen(s => !s);

  const botaoBloquear = (unidade, positiveBtnAction, small = false) => {
    const bloqueada = !!(unidade && unidade.bloqueadoVotacao);
    const action = bloqueada ? 'Desbloquear' : 'Bloquear';
    const identificacao = `${unidade.bloco || ''} ${unidade.numero || ''}`.trim();

    return (
      <Modal
        size="tiny"
        trigger={
          <Popup
            content={bloqueada
              ? 'Liberar o acesso desta unidade votante às votações.'
              : 'Impedir temporariamente esta unidade votante de votar (ex.: inadimplência).'}
            position='top center'
            trigger={
              <Button
                className={bloqueada ? 'va-btn-acao va-btn-desbloquear' : 'va-btn-acao va-btn-bloquear'}
                icon={small}
                onClick={handleModal}
                aria-label={`${action} unidade ${identificacao}`}
              >
                <Icon name={bloqueada ? 'lock open' : 'ban'} />
                {!small && action}
              </Button>
            }
          />
        }
        header={`${action} unidade ${identificacao}?`}
        open={modalOpen}
        onClose={handleModal}
        content={bloqueada
          ? 'A unidade voltará a poder votar nas votações em andamento.'
          : 'A unidade não conseguirá votar enquanto estiver bloqueada. Você pode desbloquear quando quiser.'}
        actions={[
          {
            key: 'close',
            content: 'Cancelar',
            className: 'va-btn-acao va-btn-editar'
          }, {
            key: 'done',
            content: `Sim, ${action.toLowerCase()}`,
            className: bloqueada ? 'va-btn-acao va-btn-desbloquear' : 'va-btn-acao va-btn-bloquear-solido',
            unidade,
            onClick: positiveBtnAction
          }
        ]}
      />
    );
  };

  const botaoEditar = (unidade, small = false) => (
    <BotaoEditar
      to={`/condominios/${unidade.condominio}/unidades/editar/${unidade._id}`}
      compacto={small}
      dica="Editar dados da unidade votante e do responsável"
      rotulo={`Editar unidade ${`${unidade.bloco || ''} ${unidade.numero || ''}`.trim()}`}
    />
  );

  return (
    <Transition duration={!isNaN(animation) ? animation : 500} animation="fade up" transitionOnMount={true}>
      <List.Item className="animated-list-item va-un-item">
        <span className={`va-un-avatar ${unidade.bloqueadoVotacao ? 'bloqueada' : ''}`} aria-hidden="true">
          <Icon name={unidade.bloqueadoVotacao ? 'ban' : 'home'} />
        </span>
        <List.Content className="animated-list-content">
          <List.Header style={{ wordWrap: "break-word", fontSize: "1.2em", marginBottom: "5px", lineHeight: "1.2em" }}>
            {`${unidade.bloco} ${unidade.numero}`.trim()}
            {!!unidade.responsavel &&
              <span style={{ fontWeight: 100 }}>&nbsp;&nbsp;•&nbsp;&nbsp;{unidade.responsavel.nome}</span>
            }
            <span className={`va-unidade-status ${unidade.bloqueadoVotacao ? 'bloqueada' : 'habilitada'}`}>
              <Icon name={unidade.bloqueadoVotacao ? 'ban' : 'check circle'} />
              {unidade.bloqueadoVotacao ? 'Votação bloqueada' : 'Habilitada'}
            </span>
          </List.Header>
          <List.Description style={{ fontSize: "1.1em" }}>
            {!!unidade.responsavel && (unidade.responsavel.celular || unidade.responsavel.email) ? (
              <span className="va-unidade-contato">
                {unidade.responsavel.celular && <span><Icon name="phone" /> {unidade.responsavel.celular}</span>}
                {unidade.responsavel.email && <span><Icon name="mail outline" /> {unidade.responsavel.email}</span>}
              </span>
            ) : (
              <>Criado {moment(unidade.createdAt).fromNow()}</>
            )}
          </List.Description>
          <Responsive minWidth={768}>
            <div className="btn-right">
              {botaoEditar(unidade)}
              {botaoBloquear(unidade, bloquearHandle)}
            </div>
          </Responsive>
          <Responsive maxWidth={767}>
            <div className="btn-right">
              {botaoEditar(unidade, true)}
              {botaoBloquear(unidade, bloquearHandle, true)}
            </div>
          </Responsive>
        </List.Content>
      </List.Item>
    </Transition>
  );
};

export default Unidade;
